import React from "react"
import { Button, Result } from "antd"

// Catches a render error inside one loan page tab so the rest of the page
// (header, menu, other tabs) keeps working instead of going blank.
// Give it a key per tab so switching tabs clears a caught error.
export default class TabErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { error: null }
    }

    static getDerivedStateFromError(error) {
        return { error }
    }

    componentDidCatch(error, info) {
        console.error(`Loan page tab "${this.props.tabName || ""}" failed to render`, error, info?.componentStack)
    }

    render() {
        if (!this.state.error) return this.props.children
        return (
            <Result
                status="warning"
                title="This tab couldn't load"
                subTitle="Something in this loan's data couldn't be shown. Try again, or switch to another tab."
                extra={<Button onClick={() => this.setState({ error: null })}>Try again</Button>}
            />
        )
    }
}
